const DEFAULT_SHORT_TITLE_LETTERS_AMOUNT = 38

export function cutLongTitle(
  text: string | undefined,
  shortTextLettersAmount = DEFAULT_SHORT_TITLE_LETTERS_AMOUNT
) {
  if (!text) {
    return ''
  }
  const isTextShort = text.length < shortTextLettersAmount

  return isTextShort
    ? text
    : `${text.substring(0, DEFAULT_SHORT_TITLE_LETTERS_AMOUNT)}...`
}
